<h2 mat-dialog-title class="modal-title">
  <mat-icon class="title-icon">group</mat-icon>
  Share Session: <strong>{{ data.session.name }}</strong>
  <button mat-icon-button class="close-btn" (click)="close()" matTooltip="Close">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="modal-content">

  <!-- ── Make Public section ── -->
  <div class="share-section">
    <div class="section-heading">
      <mat-icon class="section-icon">public</mat-icon>
      <span>Public access</span>
    </div>

    <div *ngIf="publicGrant; else noPublicGrant" class="public-row active-public">
      <mat-icon class="public-icon">check_circle</mat-icon>
      <span>This session is <strong>public</strong> — visible to all users (read-only).</span>
      <button
        mat-stroked-button
        color="warn"
        class="revoke-btn"
        (click)="revokeGrant('public')"
        [disabled]="isRevoking('public')"
        matTooltip="Remove public access"
      >
        <mat-progress-spinner *ngIf="isRevoking('public')" diameter="16" mode="indeterminate"></mat-progress-spinner>
        <mat-icon *ngIf="!isRevoking('public')">lock</mat-icon>
        Make Private
      </button>
    </div>

    <ng-template #noPublicGrant>
      <div class="public-row">
        <mat-icon class="public-icon muted">lock</mat-icon>
        <span class="muted-text">Not public. Only people you invite can see this session.</span>
        <button
          mat-stroked-button
          color="primary"
          class="make-public-btn"
          (click)="makePublic()"
          [disabled]="isMakingPublic"
          matTooltip="Make visible to all users (read-only)"
        >
          <mat-progress-spinner *ngIf="isMakingPublic" diameter="16" mode="indeterminate"></mat-progress-spinner>
          <mat-icon *ngIf="!isMakingPublic">public</mat-icon>
          Make Public
        </button>
      </div>
    </ng-template>
  </div>

  <!-- ── Invite & grantees: hidden when session is public ── -->
  <ng-container *ngIf="!publicGrant">

    <mat-divider class="section-divider"></mat-divider>

    <!-- ── Add users section ── -->
    <div class="share-section">
      <div class="section-heading">
        <mat-icon class="section-icon">person_add</mat-icon>
        <span>Invite specific users</span>
      </div>
      <p class="section-hint">Enter one or more usernames or email addresses, separated by commas or spaces.</p>

      <form [formGroup]="addForm" (ngSubmit)="shareWithUsers()" class="add-form">
        <mat-form-field appearance="outline" class="identifiers-field">
          <mat-label>Usernames or emails</mat-label>
          <input matInput formControlName="identifiers" placeholder="alice, bob@example.com" autocomplete="off">
        </mat-form-field>

        <div class="add-form-actions">
          <button
            mat-flat-button
            color="primary"
            type="submit"
            [disabled]="addForm.invalid || isSharing"
            class="share-btn"
          >
            <mat-progress-spinner *ngIf="isSharing" diameter="18" mode="indeterminate"></mat-progress-spinner>
            <mat-icon *ngIf="!isSharing">send</mat-icon>
            Share
          </button>
        </div>
      </form>

      <div *ngIf="shareError" class="share-error">
        <mat-icon class="error-icon">warning</mat-icon>
        {{ shareError }}
      </div>
    </div>

    <!-- ── Current grantees (owner only) ── -->
    <ng-container *ngIf="data.isOwner !== false">
      <mat-divider class="section-divider"></mat-divider>

      <div class="share-section">
        <div class="section-heading">
          <mat-icon class="section-icon">group</mat-icon>
          <span>People with access</span>
        </div>

        <div *ngIf="isLoadingGrants" class="grants-loading">
          <mat-spinner diameter="32" strokeWidth="3"></mat-spinner>
        </div>

        <div *ngIf="grantsError && !isLoadingGrants" class="share-error">{{ grantsError }}</div>

        <div *ngIf="!isLoadingGrants && userGrants.length === 0 && !grantsError" class="empty-grants">
          <mat-icon>person_off</mat-icon>
          <span>No individual users have been invited yet.</span>
        </div>

        <ul *ngIf="!isLoadingGrants && userGrants.length > 0" class="grantees-list">
          <li *ngFor="let grant of userGrants" class="grantee-row">
            <div class="grantee-info">
              <mat-icon class="grantee-icon">account_circle</mat-icon>
              <div class="grantee-details">
                <span class="grantee-name">{{ grant.granted_to_username ?? grant.granted_to_email }}</span>
                <span class="grantee-email" *ngIf="grant.granted_to_username && grant.granted_to_email">{{ grant.granted_to_email }}</span>
              </div>
              <span class="permission-badge" [class.write]="grant.can_write" [class.read]="!grant.can_write">
                {{ grant.can_write ? 'Write' : 'Read' }}
              </span>
            </div>
            <button
              mat-icon-button
              color="warn"
              class="revoke-icon-btn"
              (click)="revokeGrant(grant.granted_to_username ?? grant.granted_to_email ?? '')"
              [disabled]="isRevoking(grant.granted_to_username ?? grant.granted_to_email ?? '')"
              matTooltip="Remove access"
            >
              <mat-progress-spinner *ngIf="isRevoking(grant.granted_to_username ?? grant.granted_to_email ?? '')" diameter="18" mode="indeterminate"></mat-progress-spinner>
              <mat-icon *ngIf="!isRevoking(grant.granted_to_username ?? grant.granted_to_email ?? '')">person_remove</mat-icon>
            </button>
          </li>
        </ul>
      </div>
    </ng-container>

  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button mat-flat-button color="primary" (click)="close()">Done</button>
</mat-dialog-actions>
